import React, { useEffect, useState } from "react";
import { config } from '../../data/config';
import { Button } from "rsuite";
import axios from "axios";
import { getCookies } from "cookies-next";

const CHUNK_SIZE = 512 * 1024; // 1MB per chunk
interface MyComponentProps {
  component: string;
  id: string;
}
const ChunkedFileUpload: React.FC<MyComponentProps> = ({ component, id }) => {

  let cookie = getCookies();

  const [file, setFile] = useState<File | null>(null);
  const [progress, setProgress] = useState<number>(0);
  const [uploading, setUploading] = useState<boolean>(false);
  const [data, setData] = useState<any>(null);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;
    setFile(selectedFile);
  };

  const uploadFile = async () => {
    if (!file) return;
    await deletedItem();
    setUploading(true);
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const uniqueFileId = `${file.name}-${Date.now()}`;

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      
      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("filename", uniqueFileId);
      formData.append("chunkIndex", chunkIndex.toString());
      formData.append("totalChunks", totalChunks.toString());
      formData.append("originalFileName", file.name);
      formData.append("component", component);
      formData.append("id", id);
      try {
        await fetch(`${config.url}/v1/dashboard/cunkupload`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: 'Bearer ' + cookie['token']
          }
        });
        setProgress(((chunkIndex + 1) / totalChunks) * 100);
      } catch (error) {
        console.error("Error uploading chunk:", error);
        setUploading(false);
        return;
      }
    }

    setUploading(false);
    loadimage();
  };
  const loadimage = async () => {
        let item = await axios.get(`${config.url}/v1/dashboard/cunkupload/${id}`, {
      headers: {
        Authorization: 'Bearer ' + cookie['token'],
        "Content-Type": "multipart/form-data"
      }
    });

    setData(item.data.message);

  }

  const deletedItem = async () => {
    await axios.delete(`${config.url}/v1/dashboard/cunkupload/${id}`, {
      headers: {
        Authorization: 'Bearer ' + cookie['token'],
      }
    });
   loadimage();
  }
  useEffect(() => {

    loadimage();
  }, []);

  return (
    <div className="p-4 border rounded-lg shadow-lg w-96 mx-auto text-center">
      <h2 className="text-lg font-bold mb-4">فیلم خود را آپلود کنید</h2>
      {
        data != null && <video controls src={config.fronturl + data.url}></video>
      }
      <input type="file" onChange={handleFileChange} className="mb-4" />
      <button
        onClick={uploadFile}
        className="bg-blue-500 text-white px-4 py-2 rounded"
        disabled={!file || uploading}
        
      >
        {uploading ? "Uploading..." : "Upload"}
      </button>
      <div className="mt-4">
        <Button onClick={(e) => { deletedItem() }}>پاک کردن</Button>

        <progress value={progress} max="100" className="w-full"></progress>
        <p>{Math.round(progress)}% Uploaded</p>
      </div>
    </div>
  );
};

export default ChunkedFileUpload;
